import React, { memo, useMemo } from 'react';
import { Accordion, Table } from 'onefaceui-react-components';
import PropTypes from 'prop-types';

import { getResourceTo } from 'react/utils/chatUtils';

function CostsSection({ route }) {
  const formattedValues = useMemo(() => {
    if (!route.plannedCost && !route.actualCost) return null;

    const format = (value) => new Monet.Format.DECIMAL(value).format().getValue();

    return {
      plannedCost: format(route.plannedCost),
      actualCost: format(route.actualCost)
    };
  }, [route]);

  if (!route.plannedCost && !route.actualCost) return null;

  return (
    <Accordion
      variant="transparent"
      size="sm"
      label={getResourceTo('routePanel.cost')}
      dataTestId="costs-section"
    >
      <Table
        columns={[
          {
            title: getResourceTo('route.plannedCost'),
            field: 'planned',
            resizable: false,
            headerSort: false,
            hozAlign: 'center'
          },
          {
            title: getResourceTo('route.actualCost'),
            field: 'actual',
            resizable: false,
            headerSort: false,
            hozAlign: 'center'
          }
        ]}
        defaultData={[
          {
            planned: formattedValues.plannedCost,
            actual: formattedValues.actualCost
          }
        ]}
      />
    </Accordion>
  );
}

CostsSection.propTypes = {
  route: PropTypes.object.isRequired
};

export default memo(CostsSection);
